<template>
    <div>
        <Pessoa v-if="m_tela === PESSOA" v-model="pedido" @nextPage="irParaEndereco()" @prevPage="voltar()" />
        <Endereco v-if="m_tela === ENDERECO" v-model="pedido" @nextPage="avancar()" @prevPage="irParaPessoa()" />
    </div>
</template>

<script>
  import Pessoa from './Pessoa'
  import Endereco from './Endereco'

  export default {
    name: 'Cliente',
    components: { Pessoa, Endereco },
    props: { value: Object, tela: { type: String, validators: ['pessoa', 'endereco'] } },
    data: () => ({
      pedido: {},
      m_tela: ''
    }),
    computed: {
      PESSOA: () => 'pessoa',
      ENDERECO: () => 'endereco'
    },
    created () {
      this.pedido = Object.assign({}, this.pedido, this.value)
      this.m_tela = this.tela || this.PESSOA
    },
    methods: {
      async irParaPessoa () {
        this.pedido.backing_register = true
        this.m_tela = this.PESSOA
      },
      irParaEndereco () {
        this.$emit('input', this.pedido)
        this.m_tela = this.ENDERECO
      },
      avancar () {
        this.$emit('input', this.pedido)

        this.$emit('nextPage')
      },
      voltar () {
        this.$emit('input', this.pedido)
        this.$emit('prevPage')
      }
    }
  }
</script>

<style scoped>
</style>
